import React, { useEffect, useState } from "react";
import GenericList from "../shared/components/GenericList";
import { GridColDef } from "@mui/x-data-grid";
import { betsileoUrl, questionnaireUrl, suiviMensuelUrl } from "../../configs/URL";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Line, LineChart } from "recharts";
import { Grid2 } from "@mui/material";


export interface SuiviMensuel {
    id: number;
    _1_Nom_du_prestataire_quipe_de: string;
    _2_Type_de_service_de_collecte_: string;
    _3_Fr_quence_de_la_c_ecte_jour_semaine_: number;
    _4_Nombre_de_m_nages_desservis_: number;
    _5_Nombre_d_agents_d_ecte_sur_le_terrain_: number;
    _6_Nom_de_l_agent_quipe_: string;
    _7_Type_d_quipement_mion_chariot_etc_: string;
    _8_Fr_quence_de_coll_hebdomadaire_etc_: string;
    _9_Volume_de_d_chets_collect_s_: string;
    _10_Temps_moyen_par_tourn_e_: string;
    _11_Probl_mes_rencontr_s_: string;
    Autre_probl_me: string;
    _12_Conditions_de_travail_EPI: string;
    _13_S_curit_accidents_incidents_: string[];
    _14_Suggestions_des_agents: string;
    _15_Nombre_de_personnes_dans_le_m_nage: string;
    _16_Fr_quence_du_service_de_co: string;
    Autre_frequence_du_service_de_collecte: string;
    _17_Satisfaction_sur_lit_de_la_collecte_: string;
    _18_Propret_de_la_r_age_des_collecteurs_: string;
    _19_Mode_de_stockage_s_avant_la_collecte_: string;
    Autre_mode_de_stockage: string;
    _20_Tri_des_d_chets_: string[];
    Quele_type_de_dechet: string[];
    _21_Probl_mes_rencon_lai_propret_etc_: string;
    _22_Suggestions_pour_m_liorer_le_service_: string;
    _23_Localisation_du_int_de_regroupement_: string;
    _24_Type_de_site_de_regroupeme: string;
    Autre_site_de_regroupement: string;
    _25_Fr_quence_de_collecte_du_site_: string;
    _26_Propret_du_site_: string;
    _27_Probl_mes_rencontr_s_au_site_: string[];
    _28_Responsable_du_site_: string;
    Date: Date;
    _29_Pr_sence_de_d_chets_non_co: string;
    Combien_de_jour_par_semaine: number;
    _30_Incidences_sanitaires_obse: string[];
    Autre_incidences_sanitaire: string;
    _31_Br_lage_des_d_chets_par_les_m_nages_: string;
    _32_Impact_environne_es_zones_sensibles: string;
    _33_Fr_quence_des_ne_points_de_collecte_: string;
    _34_Nettoyage_des_ru_age_des_collecteurs_: string;
    _35_Co_t_mensuel_est_ollecte_des_d_chets_: string;
    _36_Co_t_moyen_par_t_e_d_chets_collect_e_: string;
    _37_Quantit_de_carb_a_collecte_litres_: string;
    _38_Co_t_des_quipements_n_cessaires_: string;
    _39_Recettes_li_es_contributions_etc_: string;
    _40_Taux_de_couvertu_m_nages_desservis_: string;
    _41_Satisfaction_des_usagers_: string;
    _42_Nombre_de_plaint_du_service_re_ues_: number;
    _43_Probl_mes_majeur_dant_la_pr_collecte_: string;
    signature_responsable: string;
    signature_Agent: string;
}


export const SuiviMensuelTable: React.FC = () => {
    const [data, setData] = useState<SuiviMensuel[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
    
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await fetch(suiviMensuelUrl);
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const json = await res.json();
                console.log(json);

                // Mapper uniquement les champs qui nous intéressent
                const mapped: SuiviMensuel[] = json.results.map((r: any) => {
                    var result: SuiviMensuel = r
                    result.id = r._id
                    return result
                })
                setData(mapped.sort((a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime()));
            } catch (err: any) {
                setError(err.message || "Erreur de chargement");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) return <div>Chargement…</div>;
    if (error) return <div style={{ color: "red" }}>Erreur: {error}</div>;

    // Define columns for GenericList


    const SuiviMensuelField: GridColDef[] = [
        {field : 'Date', headerName : 'Date', width : 150},
        { field: '_1_Nom_du_prestataire_quipe_de', headerName: 'Nom du prestataire/équipe de', flex: 2 },
        { field: '_2_Type_de_service_de_collecte_', headerName: 'Type de service de collecte', width : 200 },
        { field: '_3_Fr_quence_de_la_c_ecte_jour_semaine_', headerName: 'Fréquence de la collecte (jour/semaine)', width : 200 },
        { field: '_4_Nombre_de_m_nages_desservis_', headerName: 'Nombre de ménages desservis', width : 200 },
        { field: '_5_Nombre_d_agents_d_ecte_sur_le_terrain_', headerName: 'Nombre d’agents sur le terrain', width : 200 },
        { field: '_6_Nom_de_l_agent_quipe_', headerName: 'Nom de l’agent/équipe', flex: 2 },
        { field: '_7_Type_d_quipement_mion_chariot_etc_', headerName: 'Type d’équipement (camion, chariot, etc.)', width : 200 },
        { field: '_8_Fr_quence_de_coll_hebdomadaire_etc_', headerName: 'Fréquence de collecte hebdomadaire', width : 200 },
        { field: '_9_Volume_de_d_chets_collect_s_', headerName: 'Volume de déchets collectés', width : 200 },
        { field: '_10_Temps_moyen_par_tourn_e_', headerName: 'Temps moyen par tournée', width : 200 },
        { field: '_11_Probl_mes_rencontr_s_', headerName: 'Problèmes rencontrés', width : 200 },
        { field: 'Autre_probl_me', headerName: 'Autre problème', width : 200 },
        { field: '_12_Conditions_de_travail_EPI', headerName: 'Conditions de travail / EPI', width : 200 },
        { field: '_13_S_curit_accidents_incidents_', headerName: 'Sécurité, accidents, incidents', width : 200 },
        { field: '_14_Suggestions_des_agents', headerName: 'Suggestions des agents', width : 200 },
        { field: '_15_Nombre_de_personnes_dans_le_m_nage', headerName: 'Nombre de personnes dans le ménage', width : 200 },
        { field: '_16_Fr_quence_du_service_de_co', headerName: 'Fréquence du service de collecte', width : 200 },
        { field: 'Autre_frequence_du_service_de_collecte', headerName: 'Autre fréquence du service de collecte', width : 200 },
        { field: '_17_Satisfaction_sur_lit_de_la_collecte_', headerName: 'Satisfaction sur la qualité de la collecte', width : 200 },
        { field: '_18_Propret_de_la_r_age_des_collecteurs_', headerName: 'Propreté de la rue / âge des collecteurs', width : 200 },
        { field: '_19_Mode_de_stockage_s_avant_la_collecte_', headerName: 'Mode de stockage avant collecte', width : 200 },
        { field: 'Autre_mode_de_stockage', headerName: 'Autre mode de stockage', width : 200 },
        { field: '_20_Tri_des_d_chets_', headerName: 'Tri des déchets', width : 200 },
        { field: 'Quele_type_de_dechet', headerName: 'Type de déchet', width : 200 },
        { field: '_21_Probl_mes_rencon_lai_propret_etc_', headerName: 'Problèmes rencontrés (propreté, etc.)', width : 200 },
        { field: '_22_Suggestions_pour_m_liorer_le_service_', headerName: 'Suggestions pour améliorer le service', width : 200 },
        { field: '_23_Localisation_du_int_de_regroupement_', headerName: 'Localisation du point de regroupement', width : 200 },
        { field: '_24_Type_de_site_de_regroupeme', headerName: 'Type de site de regroupement', width : 200 },
        { field: 'Autre_site_de_regroupement', headerName: 'Autre site de regroupement', width : 200 },
        { field: '_25_Fr_quence_de_collecte_du_site_', headerName: 'Fréquence de collecte du site', width : 200 },
        { field: '_26_Propret_du_site_', headerName: 'Propreté du site', width : 200 },
        { field: '_27_Probl_mes_rencontr_s_au_site_', headerName: 'Problèmes rencontrés au site', width : 200 },
        { field: '_28_Responsable_du_site_', headerName: 'Responsable du site', width : 200 },
        { field: '_29_Pr_sence_de_d_chets_non_co', headerName: 'Présence de déchets non conformes', width : 200 },
        { field: 'Combien_de_jour_par_semaine', headerName: 'Combien de jours par semaine', width : 200 },
        { field: '_30_Incidences_sanitaires_obse', headerName: 'Incidences sanitaires observées', width : 200 },
        { field: 'Autre_incidences_sanitaire', headerName: 'Autres incidences sanitaires', width : 200 },
        { field: '_31_Br_lage_des_d_chets_par_les_m_nages_', headerName: 'Brûlage des déchets par les ménages', width : 200 },
        { field: '_32_Impact_environne_es_zones_sensibles', headerName: 'Impact environnemental / zones sensibles', width : 200 },
        { field: '_33_Fr_quence_des_ne_points_de_collecte_', headerName: 'Fréquence des points de collecte', width : 200 },
        { field: '_34_Nettoyage_des_ru_age_des_collecteurs_', headerName: 'Nettoyage des rues par les collecteurs', width : 200 },
        { field: '_35_Co_t_mensuel_est_ollecte_des_d_chets_', headerName: 'Coût mensuel estimé collecte', width : 200 },
        { field: '_36_Co_t_moyen_par_t_e_d_chets_collect_e_', headerName: 'Coût moyen par tonne collectée', width : 200 },
        { field: '_37_Quantit_de_carb_a_collecte_litres_', headerName: 'Quantité de carburant utilisée (litres)', width : 200 },
        { field: '_38_Co_t_des_quipements_n_cessaires_', headerName: 'Coût des équipements nécessaires', width : 200 },
        { field: '_39_Recettes_li_es_contributions_etc_', headerName: 'Recettes liées aux contributions', width : 200 },
        { field: '_40_Taux_de_couvertu_m_nages_desservis_', headerName: 'Taux de couverture ménages desservis', width : 200 },
        { field: '_41_Satisfaction_des_usagers_', headerName: 'Satisfaction des usagers', width : 200 },
        { field: '_42_Nombre_de_plaint_du_service_re_ues_', headerName: 'Nombre de plaintes reçues', width : 200 },
        { field: '_43_Probl_mes_majeur_dant_la_pr_collecte_', headerName: 'Problèmes majeurs dans la précollecte', width : 200 },
        { field: 'signature_responsable', headerName: 'Signature du responsable', width : 200 },
        { field: 'signature_Agent', headerName: 'Signature de l’agent', width : 200 },
    ];


    return (
        <div style={{ padding: "16px" }}>

            <Grid2 container spacing={2} style={{ marginBottom: "16px" }}>
                <Grid2 size={6}>

                    <h3 style={{ textAlign: 'center', marginBottom: 10 }}>
                        Nombre de ménages desservis et d’agents par équipe
                    </h3>
                    <ResponsiveContainer width="100%" height={320}>
                        <BarChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="Date" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="_4_Nombre_de_m_nages_desservis_" name="Ménages desservis" fill="#8884d8" />
                            <Bar dataKey="_5_Nombre_d_agents_d_ecte_sur_le_terrain_" name="Agents sur le terrain" fill="#82ca9d" />
                        </BarChart>
                    </ResponsiveContainer>
                </Grid2>
                <Grid2 size={6}>
                    

                </Grid2>

            </Grid2>



            <GenericList columns={SuiviMensuelField} rows={data} />
        </div>
    );
};

const thStyle: React.CSSProperties = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "center",
    fontWeight: "bold",
};

const tdStyle: React.CSSProperties = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "center",
};

export default SuiviMensuelTable;
